/* eslint-disable react/react-in-jsx-scope */
import Products from "../pages/products";
import Carts from "../pages/carts";
// import PosSidebar from "./PosSidebar";


const ProductsLayout = () => {
  return (
    <div className="flex h-[calc(100vh-120px)] overflow-y-auto p-0">
      <div className="flex-row sm:flex p-0">
        <div className=" text-white">
            <Products />
        </div>
        <div className="">
            <Carts />
        </div>
      </div>
    </div>
  )
}

export default ProductsLayout